import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Systemoppdatering for å tvinge frem ny Vercel-deploy
// Verifisert av Thomas Admin
console.log("HMSVarsling System: Initialiserer...");

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);